/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { DataSourceFromJSON, DataSourceToJSON, SheetFromJSON, SheetToJSON, StartingCellFromJSON, StartingCellToJSON, } from './';
export function DataBlockFromJSON(json) {
    return DataBlockFromJSONTyped(json, false);
}
export function DataBlockFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        startingCell: StartingCellFromJSON(json['startingCell']),
        rowTagIds: !exists(json, 'rowTagIds') ? undefined : json['rowTagIds'],
        columnTagIds: !exists(json, 'columnTagIds') ? undefined : json['columnTagIds'],
        templateRow: !exists(json, 'templateRow') ? undefined : json['templateRow'],
        templateColumn: !exists(json, 'templateColumn') ? undefined : json['templateColumn'],
        sheets: json['sheets'].map(SheetFromJSON),
        dataSource: DataSourceFromJSON(json['dataSource']),
        style: !exists(json, 'style') ? undefined : json['style'],
    };
}
export function DataBlockToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        startingCell: StartingCellToJSON(value.startingCell),
        rowTagIds: value.rowTagIds,
        columnTagIds: value.columnTagIds,
        templateRow: value.templateRow,
        templateColumn: value.templateColumn,
        sheets: value.sheets.map(SheetToJSON),
        dataSource: DataSourceToJSON(value.dataSource),
        style: value.style,
    };
}
